module.exports = __webpack_public_path__ + "img/print-btn.897a2f98.svg";